import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { FileFormat, SiteBoxDocument } from '@core/entities/SiteBoxDocument'
import { User } from '@core/entities/user'
import { IRegisterItemAttachment } from './IRegisterItemAttachment'
import {
  RegisterItemAttachmentSource,
  RegisterItemAttachmentStatus,
} from './types'

export class RegisterItemAttachment extends Entity<IRegisterItemAttachment> {
  id: number
  propertyId: string
  status: RegisterItemAttachmentStatus
  source: RegisterItemAttachmentSource
  createdOn: string

  @Type(() => User)
  createdBy: User

  @Type(() => SiteBoxDocument)
  siteBoxDocument: SiteBoxDocument

  public getDocumentName(): string {
    return this.siteBoxDocument.name ?? ''
  }

  public getUserName(): string {
    return this.createdBy.getFullName()
  }

  public getUrl(): string | undefined {
    const document = this.siteBoxDocument.currentVersion
    return document?.documentGetUrl || document?.documentDownloadUrl
  }

  public getFileFormat(): FileFormat {
    return this.siteBoxDocument.getFileFormat()
  }

  public isImageFile(): boolean {
    return this.siteBoxDocument.isImageFile()
  }

  public isUploadSource(): boolean {
    return this.source === 'UPLOAD'
  }

  public isLive(): boolean {
    return this.status === 'LIVE'
  }

  public static new(payload: unknown): RegisterItemAttachment {
    return plainToInstance(RegisterItemAttachment, payload)
  }
}
